<template>
  <v-container fluid grid-list-md>
    <v-layout row>
      <v-flex xs12 sm4 offset-sm4>
        <v-card>
          <v-card-title>
            <span class="headline">Forgot Password?</span>
          </v-card-title>
          <v-card-text>
            Enter the email address associated with your account
            <v-form v-model="formValid" ref="form">
              <v-text-field
              label="Email"
              id="email"
              required
              v-model="email"
              v-on:keyup.enter="reset()"
              :rules="rulesEmail"
              hide-details
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue--text darken-1" text @click.native="reset">Reset Password</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'
import Rules from '@/shared/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      email: '',
      errorText: '',
      formValid: true,
      rulesEmail: [
        v => !!v || 'E-mail is required',
        v => Rules.email(v)
      ]
    }
  },

  methods: {
    reset: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        var body = {
          email: this.email
        }
        ApiRequests.passwordResetRequest(body).then(response => {
          this.$router.push({ name: 'passwordResetConfirm' })
        }).catch(e => {
          this.errorText = 'Error: ' + e
          console.log(e)
        })
      } else {
        this.errorText = 'Please enter a valid email address'
      }
    }
  }
}
</script>
